<template>
  <div class="act_countdown" :style="wrap_style">
    倒计时:
    <!--兼容几百个小时的情况，以防万一-->
    <div class="number" v-for="item in countDownTime.hour" :style="numStyle">
      {{item}}
    </div>
    :
    <div class="number" :style="numStyle">
      {{countDownTime.minute[0]}}
    </div>
    <div class="number" :style="numStyle">
      {{countDownTime.minute[1]}}
    </div>
    :
    <div class="number" :style="numStyle">
      {{countDownTime.second[0]}}
    </div>
    <div class="number" :style="numStyle">
      {{countDownTime.second[1]}}
    </div>
    :
    <div class="number" :style="numStyle">
      {{countDownTime.tenMs[0]}}
    </div>
    <div class="number" :style="numStyle">
      {{countDownTime.tenMs[1]}}
    </div>

  </div>
</template>
<script>
  import {getJSON} from '../../api/myaxios';
  import {setAccurateInterval} from '../../tools/interval'
  import {countDown} from "../../tools/countdown";


  export default {
    name: 'CountDown',
    props: {
      diff: {
        type: Number,
        default: 0
      },
      text_color:{ //文字颜色
        type:String,
        default:'#fff'
      },
      num_color:{ //数字颜色
        type:String,
        default:'#fff'
      },
      num_bg:{ //数字背景
        type:String,
        default:'https://vipcdn.mgtv.com/mrdb/2018/1231/img/timedown_bg.png'
      },
    },
    data() {
      return {}
    },
    methods: {},
    created() {

    },
    computed: {
      countDownTime() {

        return countDown(this.diff);
      },
      wrap_style(){
        return {
          color:`${this.text_color} !important`
        }
      },
      numStyle(){
        return {
          color:`${this.num_color} !important`,
          background:`url(${this.num_bg}) 0% 0% / cover no-repeat`
        }
      }

    },
    mounted() {

    },
    watch: {}
  }
</script>
<style lang="stylus" scoped>
  .act_countdown
    width 7.5rem
    justify-content center
    position relative
    display flex
    align-items center
    height .7rem
    font-size .28rem

    .number
      width .49rem
      height .7rem
      display block
      line-height @height
      text-align center
      margin 0 .02rem
      font-size .36rem



</style>






// WEBPACK FOOTER //
// src/components/ConfigUI/CountDown.vue